import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NzModalService } from "ng-zorro-antd/modal";
import { PhonePipe } from "./pipes/phone.pipe";
import { SafePipe } from "./pipes/SafePipe.pipe";

@NgModule({
  declarations: [SafePipe, PhonePipe],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SafePipe,
    PhonePipe,
  ],
  providers: [NzModalService],
})
export class SharedModule {}
